<template>
  <div class="selectArea">
    <div class="province">
      <el-select v-model="provinceValue" :disabled="disabled" placeholder="省" @change="provinceChange">
        <el-option v-for="item in province" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
    </div>
    <div class="city">
      <el-select v-model="cityValue" :disabled="disabled" placeholder="市" @change="cityChange">
        <el-option v-for="item in citys" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
    </div>
    <div class="area">
      <el-select v-model="areaValue" :disabled="disabled" placeholder="区">
        <el-option v-for="item in area" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { Select, Option } from 'element-ui';
import { pcaa } from 'area-data';
let pc86 = pcaa['86'];
let province = [];
Genprovince(province);
function Genprovince(province) {
  for (let i in pc86) {
    const lib = {
      value: i,
      label: pc86[i]
    };
    province.push(lib);
  }
}
let citys = [];

Vue.use(Select);
Vue.use(Option);
export default {
  props: ['disabled'],
  data() {
    return {
      province: province,
      provinceValue: '',
      cityValue: '',
      citys: citys,
      area: [],
      areaValue: ''
    };
  },
  methods: {
    provinceChange(v) {
      // console.log(v);
      this.GenCitys(v);
    },
    GenCitys(provinceCode) {
      // console.log(pcaa[provinceCode]);
      let citys = [];
      for (let i in pcaa[provinceCode]) {
        const lib = {
          value: i,
          label: pcaa[provinceCode][i]
        };
        citys.push(lib);
      }
      this.cityValue = '';
      this.areaValue = '';
      this.area = [];
      this.citys = citys;
    },
    cityChange(v) {
      this.GenArea(v);
    },
    GenArea(code) {
      let area = [];
      for (let i in pcaa[code]) {
        const lib = {
          value: i,
          label: pcaa[code][i]
        };
        area.push(lib);
      }
      this.areaValue = '';
      this.area = area;
    },
    getArea() {
      let provinceValue = this.provinceValue * 1;
      let cityValue = this.cityValue * 1;
      let areaValue = this.areaValue * 1;
      if (this.obj) {
        // 检测是否是直接赋值过来的
        let obj = this.obj;
        if (this.isChineseChar(this.provinceValue)) {
          provinceValue = obj.provinceValue;
        }
        if (this.isChineseChar(this.cityValue)) {
          cityValue = obj.cityValue;
        }
        if (this.isChineseChar(this.areaValue)) {
          areaValue = obj.areaValue;
        }
      }
      return {
        provinceValue,
        cityValue,
        areaValue
      };
    },
    setDefault(obj) {
      // 设置默认值
      // console.log(obj, 'obj');

      this.obj = obj;
      this.GenCitys(obj.provinceValue); // 生成城市列表
      this.GenArea(obj.cityValue); // 生成区域列表
      // 必须先生成列表后赋值 因为生成代码中包含清空
      this.provinceValue = pc86[obj.provinceValue] || '';
      this.cityValue = pcaa[obj.provinceValue][obj.cityValue] || '';
      this.areaValue = pcaa[obj.cityValue][obj.areaValue] || '';
    },
    isChineseChar(str) {
      var reg = /[\u4E00-\u9FA5\uF900-\uFA2D]/;
      return reg.test(str);
    }
  }
};
</script>
<style lang="scss" scoped>
.selectArea {
  display: flex;
  width: 100%;
  .el-select {
    display: block;
    width: 176px;
  }
  .province,
  .city,
  .area {
    margin-right: 16px;
  }
}
</style>
